import VideoType from './video-type';

export default {
  [VideoType.MOVIE]: VideoType.MOVIE,
  [VideoType.CATCHUP]: VideoType.CATCHUP,
  [VideoType.RECORDING]: VideoType.RECORDING,
};
